export { default as DisabledReportView } from 'reports/components/DisabledReportView';
export { default as DisabledReportRow } from 'reports/components/disabled/DisabledReportRow';
export { default as EmployeesAssetsReportView } from 'reports/components/EmployeesAssetsReportView';
export { default as EmployeesAssetsReportRow } from 'reports/components/employees_assets/EmployeesAssetsReportRow';
export { default as HistoricsReportView } from 'reports/components/HistoricsReportView';
export { default as HistoricsReportRow } from 'reports/components/historics/HistoricsReportRow';

export { default as InsOutsReportView } from 'reports/components/InsOutsReportView';
export { default as InsOutsReportRow } from 'reports/components/ins_outs/InsOutsReportRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/index.js